import { Popover, Divider, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getFormattedDate } from "utils/date";
import "components/common/modals/modalWrapper/ModalWrapper.css";

const TaskNotesHistoryPopover = ({
  anchorEl,
  open,
  onClose,
  patientName,
  notes,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      PaperProps={{
        sx: {
          width: 360,
          maxWidth: "90vw",
          maxHeight: "50vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <div
        className="dialog-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          flexShrink: 0,
        }}
      >
        <div>
          <div className="dialog-header__title">Communication notes history</div>
          <p
            style={{
              fontFamily: "Roboto",
              fontSize: "12px",
              color: "#949494",
              margin: "4px 0 0",
            }}
          >
            {patientName} · {notes.length} notes
          </p>
        </div>
        <Tooltip title="Close" placement="bottom">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </div>
      <Divider style={{ flexShrink: 0 }} />
      <div
        style={{
          padding: "16px 24px",
          flex: "1 1 auto",
          minHeight: 0,
          overflowY: "auto",
        }}
      >
        {notes.map((n, index) => (
          <div
            key={index}
            style={{
              padding: "10px 0",
              borderBottom:
                index < notes.length - 1 ? "1px solid #E0E0E0" : "none",
            }}
          >
            <span
              style={{
                display: "block",
                fontFamily: "Roboto",
                fontSize: "12px",
                color: "#444444",
                marginBottom: "4px",
              }}
            >
              {getFormattedDate(n.addedAt, "MM/DD/YY h:mm A")}
            </span>
            <p
              style={{
                color: "#212121",
                fontSize: "14px",
                fontFamily: "Roboto",
                fontWeight: 400,
                margin: 0,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {n.note}
            </p>
          </div>
        ))}
      </div>
    </Popover>
  );
};

export default TaskNotesHistoryPopover;
